<!--
    描述：清单检查___表格
    时间：2020-08-19
    Created by ws
-->
<template>
    <div class="w-table-layout bd-table">
        <div class="w-table-content inventoryTable"
             ref="tableContent">
            <el-table class="footerTable"
                      ref="xTable"
                      :height="tableH"
                      :data="tableData"
                      highlight-current-row
                      v-loading="loading"
                      show-summary
                      border
                      @row-click="rowClick"
                      :summary-method="getSummaries"
                      :header-cell-style="headerCellStyle"
                      :cell-class-name="cellClass"
                      :row-style="rowStyle"
                      @sort-change="sortChange"
                      @header-click="headerClick">
                <el-table-column type="index"
                                 label="序号"
                                 align="center"
                                 width="50">
                </el-table-column>
                <el-table-column prop="sname"
                                 label="单位工程名称"
                                 align="center"
                                 sortable
                                 width="150">
                </el-table-column>
                <el-table-column prop="code"
                                 label="清单编码"
                                 align="center"
                                 sortable
                                 show-overflow-tooltip
                                 width="160">
                    <template slot="header"
                              slot-scope="scope">
                        <el-cascader v-model.native.stop="filterObj.codeArr"
                                     :options="filterObj.codeList"
                                     :collapse-tags="true"
                                     class="header-cascader"
                                     :props="{ expandTrigger: 'hover', label: 'text', multiple: true }">
                        </el-cascader>
                        <span>清单编码</span>
                    </template>
                </el-table-column>
                <el-table-column header-align="center"
                                 v-if="compareArr1.length > 0"
                                 prop="type1"
                                 width="710">
                    <template slot="header"
                              slot-scope="scope">
                        <el-select v-model="priceType1"
                                   size="small">
                            <el-option v-for="(item, index) in priceTypeList"
                                       :key="'价格类别' + index"
                                       :label="item.name"
                                       :value="item.value"></el-option>
                        </el-select>
                    </template>
                    <el-table-column prop="projectName"
                                     label="清单名称"
                                     width="150"
                                     resizable
                                     :filters="filterObj.nameList"
                                     :filter-method="filterHandler"
                                     header-align="center"
                                     align="left">
                        <template slot-scope="scope">
                            <el-tooltip placement="right"
                                        :disabled="compareArr1.includes('projectFeatures')">
                                <div slot="content">{{ scope.row.projectFeatures }}</div>
                                <div>{{ scope.row.projectName }}</div>
                            </el-tooltip>
                        </template>

                    </el-table-column>
                    <el-table-column prop="projectFeatures"
                                     label="清单特征"
                                     v-if="compareArr1.includes('projectFeatures')"
                                     min-width="550"
                                     resizable
                                     sortable
                                     :sort-by="['code', 'projectFeatures']"
                                     header-align="center"
                                     align="left">
                    </el-table-column>
                    <el-table-column prop="unit"
                                     v-if="compareArr1.includes('unit')"
                                     label="计量单位"
                                     width="110"
                                     :filters="filterObj.unitList"
                                     :filter-method="filterHandler"
                                     header-align="center"
                                     align="center"></el-table-column>
                    <el-table-column prop="quantity"
                                     v-if="compareArr1.includes('quantity')"
                                     label="工程量"
                                     sortable
                                     width="110"
                                     header-align="center"
                                     align="right">
                        <template slot-scope="scope">
                            <div>{{ scope.row.quantity ? scope.row.quantity.toFixed(3) : '0.000' }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="rateCost"
                                     v-if="compareArr1.includes('rateCost')"
                                     label="单价"
                                     sortable
                                     width="100"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip>
                        <template slot-scope="scope">
                            <div :class="{'color-red': scope.row.isRed}">
                                {{ scope.row.rateCost ? scope.row.rateCost.toFixed(2) : '0.00' }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="addup"
                                     v-if="compareArr1.includes('addup')"
                                     label="合价"
                                     sortable
                                     width="120"
                                     header-align="center"
                                     align="right"
                                     show-overflow-tooltip>
                         <template slot-scope="scope">
                            <div>{{ scope.row.addup ? scope.row.addup.toFixed(2) : '0.00' }}</div>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {
        selectAnalysis,
        selectConditionArray
    } from '@/api/modules/analysisDetail'
    import {getListInfo} from '@/api/modules/analysisInventory'

    export default {
        name: 'project-list',
        props: {
            // 查询参数
            searchForm: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            // 编码列表
            codeList: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                tableH: 100, // 表格高度
                pageSize: 10, // 当前显示条数
                fixedData: [], // 固定的原始数据
                tableData: [],
                priceTypeList: [],
                priceType1: '1007002', // 默认控制价
                loading: false,
                curColumn: '', // 当前点击的列 property
                // 对比列 列过滤
                compareArr1: [
                    'projectFeatures',
                    'unit',
                    'quantity',
                    'rateCost',
                    'addup'
                ],
                totalSum: 0, // 合价合计
                filterObj: {
                    codeArr: [], // 当前绑定的编码数组
                    codeList: [], // 全部编码数组
                    // 清单名称过滤数组
                    nameList: [],
                    // 计量单位数组
                    unitList: []
                },
                isStripe: true,
                timer: null,
                status: true,
                colorFlag: '0'
            }
        },
        created() {
            // 初始获得表格数据
            this.getPeriods()
            // this.getTableData()

            this.$nextTick(() => {
                this.tableH = this.$refs.tableContent.offsetHeight
            })
        },
        methods: {
            // 初始获得数据
            getTableData(params) {
                this.colorFlag = '0'
                this.tableData = []

                if (params.treeIds.length > 0) {
                    this.loading = true
                    getListInfo(params).then(res => {
                        this.loading = false
                        this.colorFlag = res.data.colorFlag
                        for (let i = 0, len = res.data.records.length; i < len; i++) {
                            // 从第二行开始
                            if (i > 0) {
                                let is_code = res.data.records[i].code.slice(0, 9) === res.data.records[i - 1].code.slice(0, 9)
                                let is_features = res.data.records[i].projectFeatures === res.data.records[i - 1].projectFeatures
                                if (is_code && is_features) {
                                    res.data.records[i].isStripe = res.data.records[i - 1].isStripe
                                    res.data.records[i].isRed = this.colorFlag === '1' && res.data.records[i].isStripe === res.data.records[i - 1].isStripe && res.data.records[i].rateCost !== res.data.records[i - 1].rateCost
                                } else {
                                    res.data.records[i].isStripe = !res.data.records[i - 1].isStripe
                                    res.data.records[i].isRed = false
                                }
                            } else {
                                res.data.records[i].isStripe = true
                                res.data.records[i].isRed = false
                            }
                        }
                        this.tableData = res.data.records
                    })
                }
            },

            // 初始获取期数
            getPeriods() {
                this.priceTypeList = []
                selectConditionArray({
                    id: this.curProjectId
                    // tag: 0, // 当前还是累计
                })
                    .then(res => {
                        this.priceTypeList = res.data
                    })
                    .catch(err => {
                    })
            },

            // 行单击事件
            rowClick(row, clolumn, event) {
                this.$emit('rowClick', row)
            },

            // 重新调整表格高度
            resizeTable() {
                setTimeout(() => {
                    this.$refs.xTable.doLayout()
                    this.tableH = this.$refs.tableContent.offsetHeight
                }, 1000)
            },

            // 列类名
            cellClass({row, column, rowIndex, columnIndex}) {
                // 类型1 的
                if (this.curColumn === 'type1') {
                    if (
                        column.property === this.priceType1 + '.projectFeatures' ||
                        column.property === this.priceType1 + '.unit' ||
                        column.property === this.priceType1 + '.quantity' ||
                        column.property === this.priceType1 + '.rateCost' ||
                        column.property === this.priceType1 + '.addup'
                    ) {
                        return 'active-cell'
                    } else {
                        return ''
                    }
                }

                // 增减量的
                if (this.curColumn === 'amount') {
                    if (
                        column.property === 'decrement.decrementQuality' ||
                        column.property === 'decrement.decrementRateCost' ||
                        column.property === 'decrement.decrementAddup'
                    ) {
                        return 'active-cell'
                    } else {
                        return ''
                    }
                }

                // 增减幅度的
                if (this.curColumn === 'amountRate') {
                    if (
                        column.property === 'range.rangeQuality' ||
                        column.property === 'range.rangePrice' ||
                        column.property === 'range.rangeSumPrice'
                    ) {
                        return 'active-cell'
                    } else {
                        return ''
                    }
                }

                // 剩下单独的
                if (this.curColumn === column.property) {
                    return 'active-cell'
                } else {
                    return ''
                }
            },

            // 表头列样式
            headerCellStyle({row, column, rowIndex, columnIndex}) {
                if (column.children && !column.label) {
                    if (column.property === 'type2') {
                        return {backgroundColor: '#039be5 !important'}
                    }
                }

                if (column.level === 2) {
                    if (
                        column.property === 'str2.projectName' ||
                        column.property === 'str2.projectFeatures' ||
                        column.property === 'str2.unit' ||
                        column.property === 'str2.quantity' ||
                        column.property === 'str2.rateCost' ||
                        column.property === 'str2.addup'
                    ) {
                        return {backgroundColor: '#039be5 !important'}
                    }
                }
            },

            // 获取当前选择的对比列 名称
            getColumnName() {
                let params = {
                    column1: '',
                    column2: ''
                }

                if (this.priceTypeList.length > 0) {
                    let _item1 = this.priceTypeList.find(
                        x => x.value === this.priceType1
                    )
                    params.column1 = _item1 ? _item1.name : ''
                }

                return params
            },

            // 清除所有列过滤
            clearFilter() {
                this.$refs.xTable.clearFilter()
            },

            // 表尾合计行
            getSummaries(param) {
                this.$nextTick(() => {
                    this.$refs.xTable.doLayout()
                })
                const {columns, data} = param
                const sums = []
                let sum2 = 0,
                    sum1 = 0

                columns.forEach((column, index) => {
                    sums[index] = null

                    if (index === 0) {
                        sums[index] = '合计'
                        return
                    }

                    // 工程量
                    if (column.property === 'quantity') {
                        let values = data.map(x => parseFloat(x.quantity))

                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr)
                                if (!isNaN(value)) {
                                    return prev + curr
                                } else {
                                    return prev
                                }
                            }, 0)
                            sum1 = sums[index]
                            sums[index] = sums[index].toFixed(3)
                        }
                    }

                    // 第一个 合价
                    if (column.property === 'addup') {
                        let values = data.map(x => parseFloat(x.addup))

                        if (!values.every(value => isNaN(value))) {
                            sums[index] = values.reduce((prev, curr) => {
                                const value = Number(curr)
                                if (!isNaN(value)) {
                                    return prev + curr
                                } else {
                                    return prev
                                }
                            }, 0)
                            sum1 = sums[index]
                            sums[index] = sums[index].toFixed(2) + ' 元'
                        }
                    }
                })
                this.totalSum = sums[sums.length - 1]
                return sums
            },

            // 表头点击事件
            headerClick(column, event) {
                this.curColumn = column.property
            },

            // 获取 当前选中的 name
            getPhaseType() {
                let _type = this.priceTypeList.find(
                    x => x.value === this.priceType1
                )
                    ? this.priceTypeList.find(x => x.value === this.priceType1).type
                    : 1
                return _type
            },

            // 行样式
            rowStyle({row, rowIndex}) {
                if (this.colorFlag === '0') {
                    return {}
                }

                if (row.isStripe) {
                    return {
                        backgroundColor: '#FFFBE0'
                    }
                }
            },

            // 列筛选
            filterHandler(value, row, column) {
                const property = column['property']
                return row[property] === value
            },

            // 排序
            sortMethod1(a, b) {
                let _prev = a.code.slice(0, 9)
                let _cur = b.code.slice(0, 9)

                return _prev - _cur && a.projectFeatures - b.projectFeatures
            },

            // 延时
            doDelay(params) {
                // 如果此时定时器在， 清除
                if (this.timer) {
                    clearTimeout(this.timer)
                }

                // 没继续点击后 做操作处理
                this.timer = setTimeout(() => {
                    this.status = true
                    if (this.status) {
                        this.getTableData(params)
                    }
                }, 1200)
            },

            // 清除排序
            clearSort() {
                this.colorFlag = '0'
                this.$refs.xTable.clearSort()
            },

            // 排序变化事件
            sortChange() {
                this.colorFlag = '0'
            }
        },
        computed: {
            ...mapState('app', {
                clientSize: state => state.clientSize
            }),
            curProjectId() {
                return this.$route.query.projectId
            }
        },
        watch: {
            clientSize(obj) {
                this.tableH = this.$refs.tableContent.offsetHeight
            },
            // 监听两个下拉选的变化
            priceType1(val) {
                let params = Object.assign({}, this.searchForm)
                params.phase = val
                params.type = this.getPhaseType()

                this.getTableData(params)
            },
            'filterObj.codeArr': {
                handler: function (arr) {
                    this.status = false
                    let params = Object.assign({}, this.searchForm)
                    params.code = arr.map(x => x[x.length - 1])


                    this.doDelay(params)
                },
                deep: true
            }
        }
    }
</script>

<style lang="less" scoped>
	.inventoryTable{
		.color-red {
			color: #ff4a0d;
		}
	}
    .footerTable {
        box-sizing: unset !important;
    }

    .moreBtn {
        color: #fff;
        font-size: 16px;
    }

    .moreList {
        position: absolute;
        background-color: #fff;
        width: 100px;
        height: 200px;
    }

    /deep/ .cell.highlight {
        color: #e6a23c !important;
    }

    /deep/ .el-table__column-filter-trigger {
        margin-left: 10px;

        i {
            color: #fff;
            font-size: 15px;
        }
    }

    .header-cascader {
        width: 30px;
        margin-right: 10px;
        overflow: hidden;
        vertical-align: middle;
        height: 25px;
        border-radius: 5px;

        /deep/ .el-input__suffix {
            right: 3px;
        }

        /deep/ .el-input__suffix-inner {
            margin-top: -15px;
            display: inline-block;
            vertical-align: middle;

            .el-input__icon {
                margin-left: 7px;
            }
        }

        /deep/ .el-cascader__tags {
            visibility: hidden;
        }
    }

    /deep/ .el-table__footer {
        td {
            background-color: #0073ab;
            color: #fff;
        }
    }
</style>
